import React, { useEffect, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL || '';

/**
 * MobileGoogleSignin
 * ------------------
 * Loaded ONLY inside the external Chrome browser that the mobile app opens
 * via Capacitor Browser plugin. Google Identity Services blocks its OAuth
 * button inside Android WebViews, so we route Google login through the real
 * Chrome tab. After successful sign-in the page deep-links the resulting JWT
 * back into the native app via the custom URL scheme com.nerdnation.app://
 *
 * URL: https://nerdnation.world/mobile-google-signin
 */
const MobileGoogleSignin = () => {
  const [status, setStatus] = useState('Tap the Google button below to continue');

  const bounceBack = (token) => {
    // The native app catches this via its intent-filter on
    // scheme="com.nerdnation.app" and re-hydrates the session.
    window.location.href = `com.nerdnation.app://login?token=${encodeURIComponent(token)}`;
    setTimeout(() => {
      try { window.close(); } catch (e) { /* noop */ }
    }, 800);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-lg p-6 text-center">
        <img
          src="/nerd-nation-logo-white.png"
          alt="Nerd Nation"
          className="h-12 mx-auto mb-4 rounded"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        <h1 className="text-xl font-bold text-gray-900 mb-1">Continue with Google</h1>
        <p className="text-sm text-gray-500 mb-6" data-testid="mobile-google-status">{status}</p>

        <div className="flex justify-center [&>div]:!w-full [&_iframe]:!w-full">
          <GoogleLogin
            onSuccess={async (credentialResponse) => {
              setStatus('Signing you in…');
              try {
                const response = await axios.post(`${API}/api/auth/google-direct`, {
                  credential: credentialResponse.credential,
                });
                const { access_token } = response.data;
                setStatus('Success! Returning to the Nerd Nation app…');
                bounceBack(access_token);
              } catch (err) {
                const msg = err.response?.data?.detail || 'Google sign-in failed. Please try again.';
                setStatus(msg);
                toast.error(msg);
              }
            }}
            onError={() => {
              setStatus('Google sign-in was cancelled. You can try again.');
            }}
            theme="filled_black"
            size="large"
            text="continue_with"
            shape="rectangular"
            width="280"
            useOneTap={false}
          />
        </div>

        <p className="text-[11px] text-gray-400 mt-6">
          You are signing in through a secure browser. This tab will close automatically.
        </p>
      </div>
    </div>
  );
};

export default MobileGoogleSignin;
